import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { PREPAID_PLANS } from "../mock";
import { useBooking } from "../App";
import Reveal from "../components/Reveal";

const PlansPage = () => {
  const { openBooking } = useBooking();
  return (
    <main>
      <section className="bg-gradient-to-br from-[#eef4fb] to-[#fdf3e6] py-14 text-center">
        <div className="max-w-3xl mx-auto px-4">
          <Reveal>
            <span className="text-orange-brand font-bold text-sm uppercase tracking-wide">Prepaid Plans</span>
            <h1 className="text-3xl sm:text-4xl font-extrabold text-navy font-head mt-2">Save More with Laundryma Recharge Plans</h1>
            <p className="text-navy/70 mt-4">Lower per-kg rates, dry-clean discounts and free pickup &amp; delivery every time. No expiry — use at your convenience.</p>
          </Reveal>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {PREPAID_PLANS.map((p, i) => (
            <Reveal key={p.title} delay={i * 60}>
              <div className={`rounded-2xl p-6 h-full flex flex-col relative transition-shadow hover:shadow-xl ${p.recommended ? "bg-navy text-white shadow-xl" : "bg-white border border-gray-100 shadow-sm"}`}>
                {p.recommended && <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-orange-brand text-white text-xs font-bold px-4 py-1 rounded-full">RECOMMENDED</span>}
                <h3 className={`font-bold text-lg font-head ${p.recommended ? "text-white" : "text-navy"}`}>{p.title}</h3>
                <div className="my-3">
                  <span className={`text-3xl font-extrabold font-head ${p.recommended ? "text-orange-brand" : "text-navy"}`}>₹{p.price}</span>
                  <span className={`text-sm font-semibold ${p.recommended ? "text-white/60" : "text-navy/50"}`}> / plan</span>
                </div>
                <p className={`text-xs mb-4 ${p.recommended ? "text-white/60" : "text-navy/50"}`}>{p.note}</p>
                <ul className="space-y-2.5 flex-1 mb-5">
                  {p.features.map((f) => (
                    <li key={f} className={`flex items-start gap-2 text-sm ${p.recommended ? "text-white/85" : "text-navy/75"}`}>
                      <Check size={16} className={`shrink-0 mt-0.5 ${p.recommended ? "text-orange-brand" : "text-green-500"}`} /> {f}
                    </li>
                  ))}
                </ul>
                <button onClick={openBooking} className={`w-full font-semibold py-2.5 rounded-full transition-colors text-sm inline-flex items-center justify-center gap-2 ${p.recommended ? "bg-orange-brand hover:bg-[#e0850f] text-white" : "bg-navy hover:bg-[#153a63] text-white"}`}>
                  Choose Plan <ArrowRight size={16} />
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
};

export default PlansPage;
